import { useRouteMatch } from 'react-router-dom';
import { useQuery } from '../../hooks/routing/use-query';
import { contains } from '../../filters/operators/string';
import { shouldOpenAdvancedSearchFlag } from '../orders/constants';
import { ADVANCED_SEARCH_ID } from '../../pages/orders-page/orders-page-view-constants';

export const quickSearchFilterIdParam = 'searchById';
export const quickSearchFilterValueParam = 'searchValue';

export const useIsOnOrdersAdvancedSearchView = () => {
  const match = useRouteMatch('/orders/:statusViewId');

  return match?.params?.statusViewId === ADVANCED_SEARCH_ID;
};

export const useIsOnShipmentsAdvancedSearchView = () => {
  const match = useRouteMatch('/shipments/:statusViewId');

  return match?.params?.statusViewId === ADVANCED_SEARCH_ID;
};

export const useIsOnReturnsAdvancedSearchView = () => {
  const match = useRouteMatch('/shipments/returns/:statusViewId');

  return match?.params?.statusViewId === ADVANCED_SEARCH_ID;
};

export const useIsOnBatchesAdvancedSearchView = () => {
  const match = useRouteMatch('/shipments/batches/:statusViewId');

  return match?.params?.statusViewId === ADVANCED_SEARCH_ID;
};

export const useIsOnFulfillmentsAdvancedSearchView = () => {
  const match = useRouteMatch('/shipments/fulfillments/:statusViewId');

  return match?.params?.statusViewId === ADVANCED_SEARCH_ID;
};

export const useShipmentsBaseUrl = () => {
  const match = useRouteMatch('/shipments/:baseView');

  return match?.params?.baseView ?? '';
};

export const useLinkedQuicksearchParams = () => {
  const searchTerms = useQuery();
  const quickSearchFilterId = searchTerms.get(quickSearchFilterIdParam);
  const openFlag = searchTerms.get(shouldOpenAdvancedSearchFlag);
  if (openFlag) {
    return [];
  }
  const quickSearchValue = searchTerms.get(quickSearchFilterValueParam);
  const filters = [{ id: quickSearchFilterId, value: [quickSearchValue], operator: contains }];
  return quickSearchFilterId && quickSearchValue ? filters : undefined;
};
